import React, { useState } from "react";
import { formatNumber } from "../../../../../common/utils/helper";
import { useLanguage } from "../../../../../common/i18n/LanguageContext";

function Step4({
  isThaiTableVisible,
  rewardTypeGroups = [],
  fightlimit,
  setFightlimit,
  fightlimitUpline = {},
  handleChangeObj,
  uplineCurrencySymbol = "",
}) {
  const { t } = useLanguage();
  // Groups where "ใช้ค่าเดียวกันทั้งกลุ่ม" is checked — every stake's fight
  // limit in that group mirrors the group's first stake. While checked,
  // only the first stake's input stays editable; editing it cascades the
  // value to the rest of the group live.
  const [syncedGroupIds, setSyncedGroupIds] = useState({});

  // Matches handleChangeObj's own clamp (the parent actually passes
  // handleChangeFightLimit under this prop name, capped at 10000, not
  // 100 — see AgentAdd.jsx), so cascading behaves the same as editing
  // each field individually would.
  const clampFightLimit = (raw) => (raw > 10000 ? 10000 : raw);

  const cascadeToGroup = (group, rawValue) => {
    const value = clampFightLimit(rawValue);
    const rewardTypes = group.rewardTypes || [];
    setFightlimit((prev) => {
      const next = { ...prev };
      rewardTypes.forEach((rt) => {
        next[rt.code] = value;
      });
      return next;
    });
  };

  const handleToggleSync = (group, checked) => {
    setSyncedGroupIds((prev) => ({ ...prev, [group.id]: checked }));
    if (!checked) return;
    const firstRt = (group.rewardTypes || [])[0];
    if (!firstRt) return;
    cascadeToGroup(group, fightlimit[firstRt.code] ?? 0);
  };

  const handleFieldChange = (e, group, rt) => {
    const isFirst = (group.rewardTypes || [])[0]?.id === rt.id;
    if (syncedGroupIds[group.id] && isFirst) {
      cascadeToGroup(group, Number(e.target.value) || 0);
      return;
    }
    handleChangeObj(e, fightlimit, setFightlimit);
  };

  return (
    <div className="md:w-full h-auto flex p-2 flex-col space-y-2 bg-slate-200 rounded-lg">
      {rewardTypeGroups.length === 0 && (
        <div className="bg-white p-4 rounded-lg shadow-sm text-center text-slate-500">
          {t("member_commission_no_groups")}
        </div>
      )}

      {rewardTypeGroups.map((group) => {
        const firstRtId = (group.rewardTypes || [])[0]?.id;
        const synced = !!syncedGroupIds[group.id];
        return (
          <div
            key={group.id}
            className="w-full text-center justify p-1 rounded-sm bg-blue-400 hover:bg-blue-800"
          >
            <div className="flex items-center justify-center gap-2">
              <label className="flex items-center gap-1 text-white text-[15px] font-bold">
                <input
                  type="checkbox"
                  checked={synced}
                  onChange={(e) => handleToggleSync(group, e.target.checked)}
                />
                {t("member_commission_sync_group")}
              </label>
              <span className="text-white text-[15px] font-bold">
                {group.name}
              </span>
            </div>
            {isThaiTableVisible && (
              <div className="rounded overflow-hidden mt-1 bg-white p-2">
                {(group.rewardTypes || []).length === 0 && (
                  <span className="text-[12px] text-slate-400">
                    {t("commission_step_no_items")}
                  </span>
                )}
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2">
                  {(group.rewardTypes || []).map((rt) => {
                    const isFirst = rt.id === firstRtId;
                    const fieldDisabled = synced && !isFirst;
                    return (
                      <div
                        key={rt.id}
                        className="border-[1px] border-slate-300 rounded-lg p-2"
                        title={`${rt.code} (${rt.stake}) — ${rt.exp}`}
                      >
                        <div className="font-bold text-[12px] text-center mb-1">
                          {rt.name}
                        </div>
                        <div className="flex flex-col gap-1">
                          <div className="flex items-center gap-1">
                            <label className="text-[11px] text-slate-500 w-[70px] text-left shrink-0">
                              {t("agentadd_step_fight_limit")}
                            </label>
                            <div className="flex flex-col w-full">
                              {fightlimitUpline[rt.code] !== undefined && (
                                <span className="font-bold text-amber-500 justify-items-center items-center text-[11px] text-center">
                                  {formatNumber(fightlimitUpline[rt.code])}{" "}
                                  {uplineCurrencySymbol}
                                </span>
                              )}
                              <input
                                type="number"
                                min="0"
                                disabled={fieldDisabled}
                                className="w-full font-bold text-[12px] border-[1px] border-slate-300 rounded-lg text-center disabled:bg-slate-100 disabled:text-slate-400"
                                name={rt.code}
                                value={fightlimit[rt.code] ?? 0}
                                onChange={(e) =>
                                  handleFieldChange(e, group, rt)
                                }
                                onClick={(e) => e.target.select()}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default Step4;
